<template>
  <div>
    <a-form :form="form" style=" margin:30px 10px 10px 10px;">

      <a-form-item
              label="内容详情"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
      >
        <UEditor  style="width: 800px; height:520px;" :ueditorContent.sync="formData.content" ></UEditor>
      </a-form-item>

      <a-affix :offsetBottom="0">
        <div style="background: #fff; padding: 10px 0 20px 0 ; border-top: 1px solid #eee  ">
          <a-button   style="margin-right: 10px;" @click="prevStep">上一步</a-button>
          <a-button type="primary" :loading="saveLoading" @click="submitForm">保存</a-button>
        </div>
      </a-affix>
    </a-form>
  </div>
</template>

<script>
  import UEditor from '@/components/UEditor/'

  import { getGoodsDetail,goodsContentEdit } from '@/api/goods'

  export default {
    name: 'Step3',
    components: {
      UEditor
    },
    props: {
      goodsId: null,
      currentTab: null,
    },
    data () {
      return {
        saveLoading:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form: this.$form.createForm(this),
        formData:{
          id:0,
          content:''
        }
      }
    },
    watch:{
      currentTab(newVal){
        console.log('currentTab');
        console.log(newVal);
        if(newVal==2){
          let that = this;
          that.formData.id = that.goodsId;
          that.fetch();
        }
      }
    },
    methods: {
      fetch(){
        let that = this;
        getGoodsDetail({
          id:that.goodsId
        }).then(res => {
          that.formData =  res.data;
        }).catch(err =>{
            that.$message.error(err.data.msg);
        })
      },
      submitForm(e){
        let self = this
        e.preventDefault()
        self.form.validateFields((err, values) => {
          if (!err) {
            self.saveLoading = true;
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            goodsContentEdit({
              id:self.goodsId,
              content:self.formData.content
            }).then(res => {
                self.$message.success('保存成功')
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
          }else{
            console.log(err);
          }
        })
      },
      prevStep () {
        this.$emit('prevStep')
      },
      toOrderList () {
      }
    }
  }
</script>
<style lang="less" scoped>
  .information {
    line-height: 22px;

  .ant-row:not(:last-child) {
    margin-bottom: 24px;
  }
  }
  .money {
    font-family: "Helvetica Neue",sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 14px;
  }
</style>